import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name martini
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTIgNC4yMDcgNC4yMDdBLjcwNy43MDcgMCAwIDEgNC43MDcgM2gxNC41ODZhLjcwNy43MDcgMCAwIDEgLjUgMS4yMDd6IiAvPgogIDxwYXRoIGQ9Ik0xMiAxMnYxMCIgLz4KICA8cGF0aCBkPSJNNyAyMmgxMCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/martini
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Martini: IconNode = [
  ['path', { d: 'M12 12 4.207 4.207A.707.707 0 0 1 4.707 3h14.586a.707.707 0 0 1 .5 1.207z' }],
  ['path', { d: 'M12 12v10' }],
  ['path', { d: 'M7 22h10' }],
];

export default Martini;
